import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api.js';

export function AuthVerify() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState<'verifying' | 'error'>('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setStatus('error'); setMessage('Missing token'); return; }
    (async () => {
      try {
        await api.post('/auth/verify', { token });
        nav('/app', { replace: true });
      } catch (err) {
        setStatus('error');
        setMessage(err instanceof Error ? err.message : 'Verification failed');
      }
    })();
  }, [params, nav]);

  return (
    <div className="min-h-screen bg-ink-50 grid place-items-center px-4">
      <div className="text-center max-w-sm">
        {status === 'verifying' ? (
          <>
            <div className="w-10 h-10 mx-auto mb-4 border-2 border-ink-200 border-t-brand-500 rounded-full animate-spin" />
            <p className="text-ink-600">Verifying your link…</p>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-full bg-red-50 text-red-600 grid place-items-center mx-auto mb-4">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </div>
            <h1 className="text-xl font-semibold tracking-tight text-ink-900">Sign-in failed</h1>
            <p className="mt-2 text-ink-600">{message}</p>
            <a href="/login" className="mt-5 inline-block text-brand-700 font-medium hover:underline">Request a new link →</a>
          </>
        )}
      </div>
    </div>
  );
}
